module.exports = __webpack_public_path__ + "img/side-vx.dcc4dc53.png";